/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-05-19 11:28:50
 * @LastEditors: sj
 * @LastEditTime: 2022-05-19 11:43:20
 */

export function getChrgitmLv(chrgitmLv: string) {
  switch (chrgitmLv) {
    case '01':
      return '甲'
    case '02':
      return '乙'
    case '03':
      return '丙'
    default:
      return '-'
  }
}

// 目录类别
export function getListType(listType: string) {
  switch (listType) {
    case '101':
      return '西药中成药'
    case '102':
      return '中药饮片'
    case '103':
      return '自制药'
    case '104':
      return '名族药'
    case '201':
      return '医疗服务项目'
    case '301':
      return '医用耗材'
    default:
      return '-'
  }
}

// 人员 类别
export function getPropPsnType(PropPsnType: string) {
  switch (PropPsnType) {
    case '310':
      return '城镇职工'
    case '330':
      return '离休人员'
    case '390':
      return '城乡居民'
    case '360':
      return '二级伤残人员'
    case '99':
      return '其他'
    case '31001':
      return '职工通用类'
    default:
      return '-'
  }
}
